<section
    class="wizard-surface-shell mx-auto grid w-full gap-4  p-4 "
    [ngClass]="[maxWidthClass, contentClass]">
    <header
        *ngIf="eyebrow || title || description"
        class="flex flex-col gap-3 lg:flex-row lg:items-start lg:justify-between">
        <div class="min-w-0">
            <span *ngIf="eyebrow" class="text-xs font-semibold uppercase tracking-wide text-slate-500">
                {{ eyebrow }}
            </span>
            <h2 *ngIf="title" class="mt-1 text-xl font-semibold tracking-tight text-slate-950">
                {{ title }}
            </h2>
            <p *ngIf="description" class="mt-1 max-w-3xl text-sm text-slate-600">
                {{ description }}
            </p>
        </div>
        <ng-content select="[wizard-header-actions]"></ng-content>
    </header>

    <nav
        *ngIf="showStepper && steps?.length"
        class="wizard-surface-stepper flex gap-0 overflow-x-auto overflow-y-hidden border-b border-white/60"
        aria-label="Wizard steps">
        <button
            *ngFor="let step of steps; let i = index"
            type="button"
            class="relative inline-flex h-12 min-w-[7.5rem] items-center justify-center gap-2 px-3 text-sm font-semibold transition disabled:cursor-not-allowed disabled:opacity-45"
            [ngClass]="currentStep === i ? 'text-slate-950' : 'text-slate-600 hover:text-slate-900'"
            [disabled]="isStepDisabled(i)"
            [attr.aria-current]="currentStep === i ? 'step' : null"
            (pointerdown)="selectStepFromPointer($event, i)"
            (click)="selectStep(i)">
            <span
                class="inline-flex h-7 w-7 shrink-0 items-center justify-center text-base"
                [ngClass]="currentStep === i ? 'text-slate-950' : 'text-slate-500'">
                <ng-container *ngIf="getStepIcon(step) as stepIcon; else stepIndex">
                    <fa-icon [icon]="stepIcon"></fa-icon>
                </ng-container>
                <ng-template #stepIndex>{{ i + 1 }}</ng-template>
            </span>
            <span class="min-w-0 truncate">{{ step.label }}</span>
            <span
                *ngIf="step.badgeLabel"
                class="wizard-surface-step-badge inline-flex shrink-0 items-center rounded-md border border-amber-300/50 bg-amber-400/10 px-1.5 py-0.5 text-[10px] font-bold uppercase leading-none text-amber-700"
                [ngClass]="step.badgeClass || ''">
                {{ step.badgeLabel }}
            </span>
            <span
                class="absolute inset-x-0 -bottom-px h-0.5 rounded-full"
                [class.bg-slate-950]="currentStep === i"></span>
        </button>
    </nav>

    <div class="min-w-0">
        <ng-content></ng-content>
    </div>

    <footer *ngIf="true" class="border-t border-white/50 pt-3">
        <ng-content select="[wizard-footer]"></ng-content>
    </footer>
</section>
